import React from "react";

import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ReportsOperatingCostSummaryList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsOperatingCostSummary/ReportsOperatingCostSummaryList/ReportsOperatingCostSummaryList"
    )
);

export const ReportsOperatingCostSummary = () => {
  return (
    <Layout>
      <ReportsOperatingCostSummaryList />
    </Layout>
  );
};
